define([
  /*eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'text!readingiq-src/js/riq-js/password-modal/1.0.0/index.html',
  'text!readingiq-src/js/riq-js/password-modal/1.0.0/index.css',
  'readingiq-src/js/riq-js/password-modal/1.0.0/vm-service/index',
  'readingiq-src/js/riq-js/password-modal/1.0.0/state-service/index'
  /*eslint-enable */
], function directive(app, aoflModules, html, css) {
  'use strict';
  var storeService = aoflModules.store;

  app.registerDirective('passwordModal', function PasswordModalDirective() {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {},
      controller: 'PasswordModalController'
    };
  });

  app.registerController('PasswordModalController', [
    'passwordModalVmService',
    'passwordModalStateService',
    '$rootScope',
    '$scope',
    function PasswordModalController(
      passwordModalVmService,
      passwordModalStateService,
      $rootScope,
      $scope
    ) {
      var _this = this;

      _this.closeModal = passwordModalVmService.closeModal;
      _this.checkPassword = passwordModalVmService.checkPassword;
      _this.continueToNextState = passwordModalVmService.continueToNextState;

      _this.password = '';
      _this.errorCodes = {wrongPassword: 'wrongPassword'};
      _this.uiText = $rootScope.getUserText().passwordModal;

      storeService.addState(passwordModalStateService);
      var mapProperties = function mapProperties() {
        var state = storeService.getState();
        _this.nextState = state.passwordModal.nextState
          ? state.passwordModal.nextState
          : state.pagearea.nextState;
        _this.errorCode = state.passwordModal.errorCode;
      };

      var unsubscribe = storeService.subscribe(function subscribe() {
        $scope.$applyAsync(mapProperties);
      });
      _this.$onDestroy = function onDestroy() {
        unsubscribe();
      };

      mapProperties();
    }
  ]);

  return {
    html,
    css
  };
});
